import React from 'react'

import PropTypes from 'prop-types'
import { useFormContext, useController } from 'react-hook-form'

import getRules from '@/shared/ui/Form/lib/rules'

const FormCheck = ({
  name,
  control,
  text,
  className = '',
  defaultValue = false,
  required,
  min,
  max,
  minLength,
  maxLength,
  pattern,
  validate,
  onChange,
  // Desestruturado para ser descartado. `rest` é espalhado depois do
  // `type="checkbox"` do input, então um `type` vindo de fora vencia o spread —
  // era assim que o `FormSwitch` mandava `type="switch"`, um tipo que não
  // existe em `<input>`, e o browser caía para campo de texto. Este componente
  // só sabe renderizar checkbox; aceitar um `type` era uma promessa falsa.
  type: _descartado,
  ...rest
}) => {
  const {
    field: { ref, value, onChange: onChangeField, ...inputProps },
    fieldState: { invalid },
    formState: { errors }
  } = useController({
    name,
    control,
    rules: getRules({ required, min, max, minLength, maxLength, pattern, validate }),
    defaultValue
  })

  const isInvalid = !!errors[name] || invalid

  const handleChange = e => {
    onChangeField(e)
    onChange && onChange(e)
  }

  return (
    <label className={`flex items-start gap-2 pt-3 cursor-pointer ${className}`}>
      <input
        id={name}
        type="checkbox"
        ref={ref}
        checked={!!value}
        onChange={handleChange}
        aria-invalid={isInvalid || undefined}
        className="mt-0.5 h-4 w-4 rounded border-gray-600 text-brand accent-[var(--color-brand)] cursor-pointer"
        {...inputProps}
        {...rest}
      />
      {text && <span className="text-sm text-gray-700">{text}</span>}
    </label>
  )
}

const FormCheckContainer = ({ name, ...rest }) => {
  const { control } = useFormContext()
  return <FormCheck name={name} control={control} {...rest} />
}

FormCheckContainer.propTypes = {
  name: PropTypes.string.isRequired
}

export { FormCheckContainer as FormCheck }
export default FormCheckContainer
